// Import React and necessary libraries
import React from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import savejamesBG from "../../assets/image/savejamesbg.avif";

const Header = () => {
  return (
    <div>
      <Navbar bg="dark" variant="dark" expand="lg" sticky="top">
        <Container>
          <Navbar.Brand href="/">
            <img
              src={savejamesBG}
              alt="savejames"
              className=""
              style={{
                // width: "217px", // Set the width to 100%
                height: "38px", // Maintain aspect ratio
              }}
            />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              <Nav.Link href="/">Home</Nav.Link>
              <Nav.Link href="/vision">Vision</Nav.Link>
              <Nav.Link href="/about">About</Nav.Link>
              <Nav.Link href="/manifesto">Manifesto</Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </div>
  );
};

export default Header;
